module.exports = __webpack_public_path__ + "static/media/ilhasvirgensbritanica.3e3628cb.jpg";